import { render, staticRenderFns } from "./OnboardingThirdQuestion.vue?vue&type=template&id=410e742a"
import script from "./OnboardingThirdQuestion.vue?vue&type=script&lang=js"
export * from "./OnboardingThirdQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports